import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { encapsulation } from '../encapsulation';
import { UBXToastService } from '../../services';
import { UBXToast, UBXToastPosition } from '../../models';

@Component({
    selector: 'ubx-toast',
    templateUrl: './toast.component.html',
    host: { class: 'ubx-toast flx f-fd:c p:fx cvr:a mg:20 pe:n zi:100' },
    encapsulation,
    animations: [
        trigger('animate', [
            transition(':enter', [
                style({ opacity: 0 }), animate('0.5s ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }), animate('0.5s ease-out', style({ opacity: 0 }))
            ]),
        ]),
        trigger('leave', [
            transition(':leave', [
                style({ opacity: 1 }), animate('0.5s ease-out', style({ opacity: 0 }))
            ]),
        ]),
    ],
})
export class UBXToastComponent implements OnInit {
    toast: Array<UBXToast> = [];
    Position = UBXToastPosition;

    constructor(
        private toastService: UBXToastService,
    ) { }

    ngOnInit() {
        this.getToast();
    }

    private getToast() {
        this.toastService.getToast().subscribe((toast: UBXToast) => {
            if (!toast) {
                return;
            }
            switch (toast.position) {
                case UBXToastPosition.BottomLeft:
                case UBXToastPosition.BottomRight:
                    this.toast.push(toast);
                    break;
                case UBXToastPosition.TopLeft:
                case UBXToastPosition.TopRight:
                    this.toast.unshift(toast);
                    break;
            }
            if (toast.timer) {
                setTimeout(() => this.removeToast(toast, toast.timer), 1000);
            }
        });
    }

    removeToast(toast: UBXToast, timer: number = 0) {
        setTimeout(() => this.toast = this.toast.filter(t => t !== toast), timer);
    }
}
